import { Box, Typography } from "@mui/material";

const Notfound = () => {
    return (
      <Box sx={{width: "100%", height: "70vh"}} display="flex" flexDirection="column" justifyContent='center' alignItems='center'>
        <Typography variant="h2">404</Typography>
        <Typography variant="h6">Halaman Tidak Ditemukan</Typography>
    </Box>
    );
}

export default Notfound;